"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index = 0;
exports.generateID = function () {
    return (index += 1);
};
//# sourceMappingURL=uid.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-mapbox-gl/lib/util/uid.js
// module id = 401
// module chunks = 0